<app-pias-layout>
    <div pias-layout-content class="template-page">

        <!-- ═══════════ Page head ═══════════ -->
        <div class="page-header-section">
            <div class="page-header-left">
                <div class="header-icon-badge">
                    <mat-icon>mail</mat-icon>
                </div>
                <h4 class="page-header">Create Template</h4>
            </div>

            <button type="button" class="preview-toggle" [class.is-on]="previewOpen"
                [matTooltip]="previewOpen ? 'Hide the preview' : 'Show the preview'" (click)="togglePreview()">
                <mat-icon>{{ previewOpen ? 'visibility_off' : 'visibility' }}</mat-icon>
                {{ previewOpen ? 'Hide Preview' : 'Show Preview' }}
            </button>
        </div>

        <div class="compose-grid" [class.is-split]="previewOpen">

            <!-- ═══════════ Template form ═══════════ -->
            <div class="compose-col">
                <div class="section-card" [formGroup]="templateFg">

                    <!-- ---- Template name ---- -->
                    <div class="form-row">
                        <label class="field-label" for="template-name">Template Name:</label>
                        <mat-form-field class="w-100">
                            <input id="template-name" matInput formControlName="templateName"
                                placeholder="Enter template name" />
                            @if (templateFg.controls['templateName'].invalid &&
                            (templateFg.controls['templateName'].touched ||
                            templateFg.controls['templateName'].dirty)) {
                            <mat-error>
                                @if (templateFg.controls['templateName'].errors?.['required']) {
                                <span>{{ message }}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <!-- ---- Description ---- -->
                    <div class="form-row">
                        <label class="field-label" for="template-description">Description:</label>
                        <div class="description-cell">
                            <mat-form-field class="w-100">
                                <textarea id="template-description" matInput rows="2" formControlName="description"
                                    placeholder="What this template is for, and when to use it"></textarea>
                            </mat-form-field>
                            <p class="field-hint">
                                Internal note only — this is not part of the email recipients receive.
                            </p>
                        </div>
                    </div>

                    <!-- ---- Channel ---- -->
                    <div class="form-row">
                        <label class="field-label">Channel:</label>
                        <div class="channel-cell">
                            <mat-form-field class="channel-select">
                                <mat-select formControlName="channel">
                                    @for (channel of channels; track channel.value) {
                                    <mat-option [value]="channel.value">{{ channel.viewValue }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <span class="field-hint">WhatsApp template authoring is not available yet.</span>
                        </div>
                    </div>

                    <!-- ---- Start date ---- -->
                    <div class="form-row">
                        <label class="field-label" for="template-start-date">Start Date:</label>
                        <mat-form-field class="date-field">
                            <input id="template-start-date" matInput formControlName="startDate"
                                [matDatepicker]="startDatePicker" [max]="templateFg.controls['endDate'].value"
                                placeholder="Choose a date" />
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                            @if (templateFg.controls['startDate'].invalid &&
                            (templateFg.controls['startDate'].touched || templateFg.controls['startDate'].dirty)) {
                            <mat-error>
                                @if (templateFg.controls['startDate'].errors?.['matDatepickerParse']) {
                                <span>Enter a valid date</span>
                                } @else if (templateFg.controls['startDate'].errors?.['matDatepickerMax']) {
                                <span>Start date must be on or before the end date</span>
                                } @else if (templateFg.controls['startDate'].errors?.['required']) {
                                <span>{{ message }}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <!-- ---- End date ---- -->
                    <div class="form-row">
                        <label class="field-label" for="template-end-date">End Date:</label>
                        <mat-form-field class="date-field">
                            <input id="template-end-date" matInput formControlName="endDate"
                                [matDatepicker]="endDatePicker" [min]="templateFg.controls['startDate'].value"
                                placeholder="Choose a date" />
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                            @if (templateFg.controls['endDate'].invalid &&
                            (templateFg.controls['endDate'].touched || templateFg.controls['endDate'].dirty)) {
                            <mat-error>
                                @if (templateFg.controls['endDate'].errors?.['matDatepickerParse']) {
                                <span>Enter a valid date</span>
                                } @else if (templateFg.controls['endDate'].errors?.['matDatepickerMin']) {
                                <span>End date must be on or after the start date</span>
                                } @else if (templateFg.controls['endDate'].errors?.['required']) {
                                <span>{{ message }}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <!-- ---- Subject ---- -->
                    @if(isEmail){
                    <div class="form-row">
                        <label class="field-label" for="template-subject">Subject:</label>
                        <mat-form-field class="w-100">
                            <input id="template-subject" matInput formControlName="subject"
                                placeholder="Enter subject here" />
                            @if (templateFg.controls['subject'].invalid &&
                            (templateFg.controls['subject'].touched || templateFg.controls['subject'].dirty)) {
                            <mat-error>
                                @if (templateFg.controls['subject'].errors?.['required']) {
                                <span>{{ message }}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }

                    <!-- ---- Message body ---- -->
                    <!-- Composed visually; the HTML is generated on save by composeHtmlDocument(). -->
                   @if(isEmail){
                    <div class="form-row">
                        <label class="field-label">Message Body:</label>
                        <div class="body-cell">
                            <app-rich-text-editor formControlName="messageBody"
                                [placeholder]="BODY_PLACEHOLDER"></app-rich-text-editor>

                            @if (templateFg.controls['messageBody'].invalid &&
                            templateFg.controls['messageBody'].touched) {
                            <p class="field-error">{{ message }}</p>
                            }

                            <div class="merge-hint">
                                <span class="merge-hint-label">Merge fields:</span>
                                @for (field of MERGE_FIELDS; track field) {
                                <span class="merge-chip">{{ field }}</span>
                                }
                            </div>
                        </div>
                    </div>
                }

                    @if (!isEmail) {
                    <!-- ---- Template ID (WhatsApp / SMS) ---- -->
                    <div class="form-row">
                        <label class="field-label" for="template-sid">Template SID:</label>
                        <mat-form-field class="w-100">
                            <input id="template-sid" matInput formControlName="templateSid"
                                placeholder="Enter template SID" />
                            @if (templateFg.controls['templateSid'].invalid &&
                            (templateFg.controls['templateSid'].touched || templateFg.controls['templateSid'].dirty)) {
                            <mat-error>
                                <span>{{ message }}</span>
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }

                    <!-- ---- Header image ---- -->
                     @if(isEmail){
                    <div class="form-row">
                        <label class="field-label">Header Image:</label>
                        <div class="image-cell">
                            @if (headerImage) {
                            <figure class="banner-slot">
                                <button type="button" class="slot-remove" matTooltip="Remove header image"
                                    (click)="removeImage('header')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <img class="slot-image" [src]="headerImage.dataUrl"
                                    [alt]="headerImage.attachment.fileName" />
                                <figcaption class="slot-caption" [matTooltip]="headerImage.attachment.fileName">
                                    <span class="slot-name">{{ headerImage.attachment.fileName }}</span>
                                    <span class="slot-size">{{ headerImage.size }}</span>
                                </figcaption>
                            </figure>
                            }

                            <label class="upload-button" [class.disabled]="!isEmail">
                                <input type="file" hidden [accept]="ACCEPTED_IMAGE_TYPES" [disabled]="!isEmail"
                                    (change)="onImageSelected($event, 'header')" />
                                <mat-icon>add_photo_alternate</mat-icon>
                                {{ headerImage ? 'Replace header image' : 'Upload header image' }}
                            </label>
                        

                            <p class="field-hint">Shown above the message. PNG, JPEG, GIF or WebP, up to 5MB.</p>
                        </div>
                    </div>
                }

                    <!-- ---- Footer image ---- -->
                     @if(isEmail){
                    <div class="form-row">
                        <label class="field-label">Footer Image:</label>
                        <div class="image-cell">
                            @if (footerImage) {
                            <figure class="banner-slot">
                                <button type="button" class="slot-remove" matTooltip="Remove footer image"
                                    (click)="removeImage('footer')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <img class="slot-image" [src]="footerImage.dataUrl"
                                    [alt]="footerImage.attachment.fileName" />
                                <figcaption class="slot-caption" [matTooltip]="footerImage.attachment.fileName">
                                    <span class="slot-name">{{ footerImage.attachment.fileName }}</span>
                                    <span class="slot-size">{{ footerImage.size }}</span>
                                </figcaption>
                            </figure>
                            }

                            <label class="upload-button" [class.disabled]="!isEmail">
                                <input type="file" hidden [accept]="ACCEPTED_IMAGE_TYPES" [disabled]="!isEmail"
                                    (change)="onImageSelected($event, 'footer')" />
                                <mat-icon>add_photo_alternate</mat-icon>
                                {{ footerImage ? 'Replace footer image' : 'Upload footer image' }}
                            </label>

                            <p class="field-hint">Shown below the message. PNG, JPEG, GIF or WebP, up to 5MB.</p>
                        </div>
                    </div>
                }

                </div>
            

                <!-- ---- Actions ---- -->
                <div class="form-actions">
                    <!-- new: Save button, next to Save Template -->
                    <button class="save-btn" type="button" (click)="onSaveTemplate()">
                        <span>Save</span>
                    </button>
                    <button class="save-btn" type="button" (click)="onSaveTemplate('Active')">
                        <span>Submit</span>
                    </button>
                    <button class="cancel-btn" type="button" (click)="onCancel()">
                        <span>Cancel</span>
                    </button>
                </div>
            </div>

            <!-- ═══════════ Live preview ═══════════ -->
            <!-- Sandboxed with neither allow-scripts nor allow-same-origin: composed markup renders
                 but cannot execute or reach this page. -->
            @if (previewOpen) {
            <div class="preview-pane">
                <div class="preview-head">
                    <div>
                        <h2 class="preview-title">Preview</h2>
                        <p class="preview-sub">Merge fields show sample values.</p>
                    </div>

                    <button type="button" class="preview-collapse" matTooltip="Collapse preview"
                        (click)="togglePreview()">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>

                <div class="preview-body">
                    <iframe class="preview-frame" title="Email template preview" sandbox [srcdoc]="previewDoc"></iframe>
                </div>
            </div>
            }

        </div>
    </div>
</app-pias-layout>